/*
  Auto-adds the Seed Growing Guide (handle: seed-guide) to the cart whenever a
  customer adds any other product. The Buy X Get Y discount in Shopify then
  applies automatically at checkout.

  Works by wrapping window.fetch so every path into /cart/add is covered:
  main product form, quick add, sticky ATC, and third-party apps.
*/
(function () {
  const GUIDE_VARIANT_ID = 47222224716097;

  const cartPath = (window.routes && window.routes.cart_url) || '/cart';
  const addPath = (window.routes && window.routes.cart_add_url) || '/cart/add';

  let inFlight = false;

  function urlOf(resource) {
    if (typeof resource === 'string') return resource;
    if (resource instanceof Request) return resource.url;
    if (resource instanceof URL) return resource.href;
    return '';
  }

  function isAddRequest(resource, init) {
    const url = urlOf(resource);
    if (!url || url.indexOf(addPath) === -1) return false;

    const method = (init && init.method) || (resource instanceof Request && resource.method) || 'GET';
    return method.toUpperCase() === 'POST';
  }

  // Pull the variant ids out of whatever body shape the caller used, so we can
  // tell whether the guide itself is what's being added.
  function addedVariantIds(init) {
    const body = init && init.body;
    if (!body) return [];

    try {
      if (body instanceof FormData) {
        const ids = [];
        if (body.has('id')) ids.push(String(body.get('id')));
        body.forEach((value, key) => {
          if (/^items\[\d+\]\[id\]$/.test(key)) ids.push(String(value));
        });
        return ids;
      }

      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          const parsed = JSON.parse(body);
          if (Array.isArray(parsed.items)) return parsed.items.map((item) => String(item.id));
          if (parsed.id !== undefined) return [String(parsed.id)];
          return [];
        }
        const params = new URLSearchParams(body);
        const ids = [];
        params.forEach((value, key) => {
          if (key === 'id' || /^items\[\d+\]\[id\]$/.test(key)) ids.push(String(value));
        });
        return ids;
      }
    } catch (e) {
      // Unrecognised body shape — treat it as a normal product add.
    }

    return [];
  }

  function guideInCart() {
    return fetch(`${cartPath}.js`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
    })
      .then((response) => response.json())
      .then((cart) => cart.items.some((item) => item.variant_id === GUIDE_VARIANT_ID))
      .catch(() => true); // On failure, skip the auto-add rather than risk a duplicate.
  }

  function addGuide() {
    return fetch(addPath, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [{ id: GUIDE_VARIANT_ID, quantity: 1 }] }),
    }).catch(() => {});
  }

  const originalFetch = window.fetch;

  window.fetch = function (resource, init) {
    if (inFlight || !isAddRequest(resource, init)) {
      return originalFetch.apply(this, arguments);
    }

    const ids = addedVariantIds(init);
    // Don't re-add the guide when the guide is the thing being added.
    const isGuideOnly = ids.length > 0 && ids.every((id) => id === String(GUIDE_VARIANT_ID));

    const args = arguments;
    const self = this;

    return originalFetch.apply(self, args).then((response) => {
      if (!response.ok || isGuideOnly) return response;

      // Add the guide before returning, so the cart sections the theme renders
      // from this response's follow-up refresh already include it.
      inFlight = true;
      return guideInCart()
        .then((present) => (present ? null : addGuide()))
        .then(() => {
          inFlight = false;
          return response;
        })
        .catch(() => {
          inFlight = false;
          return response;
        });
    });
  };
})();
